import type { Team } from "../types/team";

// Final groups, fixed for the subject draw.
export const groups: Team[] = [
  {
    id: 1,
    members: [
      { name: "Felipe Argolo", school: "link" },
      { name: "Joao Mourao", school: "link" },
      { name: "Dhevarshini", school: "mahindra" },
    ],
  },
  {
    id: 2,
    members: [
      { name: "Lorenzo Vitti", school: "link" },
      { name: "Saanvi", school: "mahindra" },
    ],
  },
  {
    id: 3,
    members: [
      { name: "Diogo Chiapeta", school: "link" },
      { name: "Aadhya", school: "mahindra" },
    ],
  },
  {
    id: 4,
    members: [
      { name: "Carol GCO", school: "link" },
      { name: "Niyathi", school: "mahindra" },
    ],
  },
  {
    id: 5,
    members: [
      { name: "Hugo Mendes", school: "link" },
      { name: "Aishwarya", school: "mahindra" },
    ],
  },
];
